import { render, staticRenderFns } from "./EventRecords.vue?vue&type=template&id=7ea7908b&scoped=true"
import script from "./EventRecords.vue?vue&type=script&lang=ts"
export * from "./EventRecords.vue?vue&type=script&lang=ts"
import style0 from "./EventRecords.vue?vue&type=style&index=0&id=7ea7908b&prod&scoped=true&lang=scss"
import style1 from "./EventRecords.vue?vue&type=style&index=1&id=7ea7908b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea7908b",
  null
  
)

export default component.exports